// Phase G3 Stage 4: /onboarding/ — landing page for the multi-step
// onboarding flow. Renders OnboardingWelcome with a "Get started"
// CTA that navigates to the first kid sub-step.
import { createFileRoute } from "@tanstack/react-router";
import { OnboardingWelcome } from "@/screens/OnboardingWelcome";

export const Route = createFileRoute("/onboarding/")({
  component: OnboardingWelcome,
});
